"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PINNED_CHANNEL_SLUGS = exports.TIKTOK_ADS_CHANNEL_SLUG = exports.GOOGLE_ADS_CHANNEL_SLUG = exports.DEFAULT_NEW_AGENT_CHANNEL_SLUG = exports.META_ADS_CHANNEL_SLUG = exports.CUSTOM_CHANNEL_SLUG = void 0;
exports.CUSTOM_CHANNEL_SLUG = 'custom';
/** Slug of the Meta Ads marketing channel — the default real channel (seeded source of truth, and the
 *  channel preselected in the approval view when a creative carries only the platform-less custom one). */
exports.META_ADS_CHANNEL_SLUG = 'meta-ads';
/**
 * Floor channel for a NEWLY started agent when the brand has no last-used channel to seed from.
 * Meta is the dominant channel and matches the generation tools' own default. The full new-agent
 * resolution is `sessionOverride ?? latestUsedChannel ?? DEFAULT_NEW_AGENT_CHANNEL_SLUG`, applied
 * by the composer surfaces (frontend) and by `getLatestChannelSlugForBrand` (backend seed endpoint).
 */
exports.DEFAULT_NEW_AGENT_CHANNEL_SLUG = exports.META_ADS_CHANNEL_SLUG;
/** Slug of the Google Ads marketing channel. */
exports.GOOGLE_ADS_CHANNEL_SLUG = 'google-ads';
/** Slug of the TikTok Ads marketing channel. */
exports.TIKTOK_ADS_CHANNEL_SLUG = 'tiktok-ads';
/** Marketing channels pinned to every brand's dashboard by default and NOT user-unpinnable
 *  (enforced server-side on unpin, and the frontend hides their remove control). */
exports.DEFAULT_PINNED_CHANNEL_SLUGS = [exports.META_ADS_CHANNEL_SLUG, exports.GOOGLE_ADS_CHANNEL_SLUG];
